import config from "@config";
import { Constants } from "@constants/Constants";

export const queryStringToObject = (query) => {
  const urlParams = new URLSearchParams(decodeURIComponent(query));
  const entries = urlParams?.entries();
  const result = {};
  for (const [key, value] of entries) {
    result[key] = value;
  }
  return result;
};

const getCookie = (cname) => {
  const name = `${cname}=`;
  const cookieList = document.cookie.split(";");
  for (let i = 0; i < cookieList.length; i++) {
    const cookieItem = cookieList[i]?.trim();
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.split("=")[1];
    }
  }
  return "";
};

export const getAuthorizationToken = (name) => {
  const domain = window.location.host;
  if (domain.indexOf(config.APP_LOCAL_PATH) !== -1) {
    return getCookie(name);
  }
  return localStorage.getItem(name);
};

const deleteCookie = (name) => {
  document.cookie =
    name +
    "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.gartner.com; path=/; ";
};

export const deleteAuthorizationToken = (name) => {
  const domain = window.location.host;
  if (domain.indexOf(config.APP_LOCAL_PATH) !== -1) {
    return deleteCookie(name);
  }
  return localStorage.removeItem(name);
};

export const getGCOMEnv = () => {
  const domain = window.location.hostname;
  if (Constants.HOST.DEV.indexOf(domain) !== -1) {
    return Constants.URLS.GARTNER_DEV;
  } else if (Constants.HOST.QA.indexOf(domain) !== -1) {
    return Constants.URLS.GARTNER_QA;
  }
  return Constants.URLS.GARTNER;
};

export const getUserRole = (roles) => {
  let userRole = Constants.GUEST_ROLE;
  if (roles?.includes(Constants.GARTNER_ASSOCIATE_ROLE)) {
    userRole = Constants.GARTNER_ASSOCIATE_ROLE;
  } else if (roles?.includes(Constants.CLIENT_ROLE)) {
    userRole = Constants.CLIENT_ROLE;
  }
  return userRole;
};

export const isProd = () => getGCOMEnv() === Constants.URLS.GARTNER;

export const getCurrentEnvForAppLauncher = () => {
  const { hostname } = window.location;
  if (hostname.indexOf('toolsdv') !== -1 || hostname.indexOf('developer.gartner.com') !== -1) {
    return 'dev';
  }
  if (hostname.indexOf('toolsqa') !== -1) {
    return 'qa';
  }
  return 'prod';
};